import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getLabDetails(id, encoded) {
        return Axios.get(`${baseURL}record/edit-medical-record/${id}`, {
            params: { encoded }
        }).then(response => response.data.response);
    },
    updateLabDetails(data) {
        return Axios.put(`${baseURL}lab`, data).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    sendEmailLab(params) {
        return Axios.post(`${baseURL}lab/send-email-lab-result`, params).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    printLab(params) {
        return Axios.post(`${baseURL}lab/print-lab-result`, params).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    getRequisitionFormUrl(params) {
        return Axios.get(`${baseURLci}patient/lab/get_requisition_form_url`, {
            params
        }).then(response => response.data);
    },
    getLabTestResult(labId) {
        return Axios.get(`${baseURL}lab/lab-test-result/${labId}`).then(
            response => response.data.response
        );
    },
    getLabTestResultHistory(data) {
        return Axios.post(`${baseURL}lab/lab-test-history`, data).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    fetchLabResult(data) {
        return Axios.post(`${baseURL}lab/pull/lab-result`, data).then(res => {
            if (res.data) {
                return res.data;
            }
            return null;
        });
    },
    async deleteRecordLab(recordId) {
        const options = {
            method: "POST",
            data: "lab_id=" + recordId,
            url: `${baseURLci}patient/lab/delete`
        };

        return Axios(options).then(response => response.data);
    },
    addAddonTest(orderId, data) {
        return Axios.post(`${baseURL}lab/add-on/order/${orderId}`, {
            item_ids: data.item_ids,
            comment: data.comment
        }).then(response => response.data.response);
    }
};
